import React from 'react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="bg-black pt-40 pb-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl md:text-7xl font-serif font-bold mb-16 text-white">Terms of Service</h1>
        <div className="prose prose-invert prose-zinc max-w-none space-y-10 text-zinc-400 text-base leading-relaxed">
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the website and services provided by Maxmark Agency ("Maxmark", "we", "us", or "our"), you agree to be bound by these Terms of Service. If you do not agree with these terms, please discontinue using our services immediately.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">2. Strategic & Intelligence Services</h2>
            <p>
              Maxmark provides advertising intelligence, competitive monitoring, brand strategy, and creative execution services. All competitive advertising analysis is derived strictly from public-facing advertising repositories and public domain data. Maxmark does not access, intercept, or request access to competitors' private advertising accounts, internal metrics, or confidential databases.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">3. Client Engagements & Subscriptions</h2>
            <p>
              Service retainers, monthly intelligence subscriptions, and creative production projects are governed by specific client service agreements (SOWs). Subscription terms, deliverable timelines, and payment structures are defined prior to project commencement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">4. Intellectual Property</h2>
            <p>
              All proprietary intelligence methodologies, framework designs, website content, branding, and codebases developed by Maxmark remain the intellectual property of Maxmark Agency until full settlement of project fees as defined under client contract.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">5. Limitation of Liability</h2>
            <p>
              Marketing and advertising intelligence provides observational insight and strategic guidance. Market conditions and competitor actions change continuously. Maxmark does not guarantee specific revenue returns or conversion figures for third-party commercial actions.
            </p>
          </section>

          <div className="pt-10 border-t border-zinc-900 flex justify-between items-center">
            <p className="text-sm italic text-zinc-600">Last updated: January 2025.</p>
            <Link to="/contact" className="text-xs font-bold uppercase tracking-widest text-blue-500 hover:text-blue-400">Questions? Contact Legal Team &rarr;</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
